var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#start_group_svg__clip0_237_80934)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.328 10.17l-.115.665.345-.181-.2 1.173a1.002 1.002 0 01-1.13-1.16l.23-1.345.87.847zm3.068-7.108L7 2.26l-.928 1.88a2 2 0 01-1.506 1.094l-2.075.301.59.576a2.025 2.025 0 00-.517.891l-.77-.75a1 1 0 01.554-1.706l2.074-.302a1 1 0 00.753-.547l.928-1.88a1 1 0 011.793 0l.3.608a1.949 1.949 0 00-.8.637zm2.752 1.265l.537 1.089-.537-1.089zm.894 1.662a1 1 0 00.535.255l.554.08-.554-.08a1 1 0 01-.535-.255zm1.452-.622l-.773-.112-.372-.753.303.044a.993.993 0 01.842.821z",
    fill: "#262A33",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.052 4.038a.5.5 0 01.896 0l1.075 2.178a1.5 1.5 0 001.13.82l2.403.35a.5.5 0 01.277.853l-1.74 1.695a1.5 1.5 0 00-.43 1.328l.41 2.393a.5.5 0 01-.725.527l-2.15-1.13a1.5 1.5 0 00-1.396 0l-2.15 1.13a.5.5 0 01-.725-.527l.41-2.393a1.5 1.5 0 00-.43-1.328l-1.74-1.695a.5.5 0 01.277-.853l2.403-.35a1.5 1.5 0 001.13-.82l1.075-2.178z",
    stroke: "#262A33",
    strokeOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "start_group_svg__clip0_237_80934"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/start_group.472717c4.svg";
export { SvgStartGroup as ReactComponent };